import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTwitterAccounts, getTwitterOrganizationSettings, } from '../api/twitter';
const prefix = `settings/twitter`;
export const twitterActions = {
    readAccounts: createAsyncThunk(`${prefix}/readAccounts`, fetchTwitterAccounts),
    getOrganizationSettings: createAsyncThunk(`${prefix}/getOrganizationSettings`, getTwitterOrganizationSettings),
};
